/**
 * De naam van een prijsbron zoals die in de overzichten staat (US-021, US-022, US-023).
 *
 * De naam, bij onze eigen bron een herkenningsteken, en een link naar de pagina. Dat stond los per
 * scherm uitgeschreven en was daardoor al uit elkaar gelopen.
 *
 * Hier heeft ook het domein onder de naam gestaan, zoals in het ontwerp. Dat is er weer uit: in een
 * kolomkop worden die letters in kapitalen weergegeven, en dan staat er twee keer bijna hetzelfde —
 * "SWDSBOUW" met "SWDSBOUW.NL" eronder. Wélke webshop het is, blijkt al uit de naam; wie de pagina
 * wil zien gebruikt het pictogram ernaast.
 *
 * Bij de eigen bron staat het bedrijfslogo wanneer dat is ingesteld, en anders een sterretje. Dat is
 * de reden dat dit een eigen onderdeel is en niet in de UI-verzameling staat: het heeft de sessie
 * nodig om te weten welk bedrijf actief is en of er een logo bij hoort.
 */

import { ExternLink } from './ui/index.js';
import { useSession } from '../session/SessionContext.js';
import styles from './BronLabel.module.css';

export function BronLabel({
  naam,
  isOwn,
  url,
  sku,
}: {
  naam: string;
  isOwn: boolean;
  url?: string | null;
  /** Artikelnummer bij de concurrent, wanneer het onder de naam hoort te staan. */
  sku?: string | null;
}): React.JSX.Element {
  const { activeCompany } = useSession();

  return (
    <div className={styles.bron}>
      <div className={styles.kop}>
        {isOwn &&
          (activeCompany?.heeftLogo ? (
            /*
               Het logo maakt in één oogopslag duidelijk dat dit onze prijs is. Bewust klein en met
               een lege alt: de naam staat er direct naast, dus voorlezen zou hem verdubbelen.
            */
            <img
              className={styles.logo}
              src={`/api/bedrijven/${activeCompany.companyId}/logo`}
              alt=""
            />
          ) : (
            <span aria-hidden="true">★</span>
          ))}
        <strong className={styles.naam}>{naam}</strong>
        {url && <ExternLink url={url} naam={isOwn ? 'onze webshop' : naam} />}
      </div>
      {sku && <div className={styles.onder}>art. {sku}</div>}
    </div>
  );
}
